import { render } from "./index.vue?vue&type=template&id=cb97de3e"
import script from "./whatWeDo.js?vue&type=script&lang=js&external"
export * from "./whatWeDo.js?vue&type=script&lang=js&external"

import "./whatWeDo.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__